<!-- @format -->

<template>
	<el-select v-model="value" placeholder="请选择下拉数据" class="select">
		<el-option v-for="item in timeTypeList" :key="item.format" :label="item.label" :value="item.format" />
	</el-select>
</template>

<script setup lang="ts">
	import { timeTypeList } from '../config';

	interface Props {
		modelValue: number | string;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: timeTypeList[0].format,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue || timeTypeList[0].format;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped>
	.select {
		width: 100%;
	}
</style>
